import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import withFieldError from 'components/form/with-error'
import { SelectPickerField } from 'components/form/selectpicker'
import CheckboxField from 'components/form/checkbox'

import { connect } from 'react-redux'
import CustomDmTemplate from '../../facebook/send-facebook-blast/custom-template'

const selector = formValueSelector('widget')

export const MessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

MessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const MessageInputWithError = withFieldError(MessageInput)

export const SendFacebookDmFields = ({
  selectedAction,
  includeBackupDms,
  experienceType,
  name
}) => {
  console.log('the experience type', experienceType)
  return (
    <div className='row select-group'>
      <div className='col-sm-4 br-no-pad-right component-select-picker'>
        <Field
          name={`${name}.action`}
          component={SelectPickerField}
          defaultValue='TEMPLATE_GENERIC'
        >
          <option value='TEMPLATE_GENERIC'>Generic DM Template</option>
          <option value='TEMPLATE_CUSTOM'>Custom Template</option>
        </Field>
        {experienceType === 'FACEBOOK_COUPON' && (
          <Field
            name={`${name}.includeBackupDms`}
            component={CheckboxField}
            label='Include fallback and depleted DMs'
            className='icheckbox_square'
          />
        )}
      </div>

      {selectedAction === 'TEMPLATE_GENERIC' && (
        <div className='col-sm-12'>
          <Field
            component={MessageInputWithError}
            label='Message'
            name={`${name}.fbDmText`}
            placeholder='DM Text'
            require
          />
          <Field
            component={MessageInputWithError}
            label='Image URL'
            name={`${name}.fbDmImageUrl`}
            placeholder='Image URL'
          />
          <Field
            component={MessageInputWithError}
            label='Template Title'
            name={`${name}.fbTemplateTitle`}
            placeholder='Template Heading'
          />
          <Field
            component={MessageInputWithError}
            label='Template Action URL'
            name={`${name}.fbTemplateActionUrl`}
            placeholder='Template Action URL (where to go when user clicks on the DM)'
          />
        </div>
      )}
      {selectedAction === 'TEMPLATE_CUSTOM' && (
        <div className='br-has-checkbox col-sm-12'>
          <Field
            component={CustomDmTemplate}
            name={`${name}.customDmTemplate`}
          />
        </div>
      )}
      {includeBackupDms && (
        <div className='col-sm-12'>
          <span>
            <strong>FALLBACK MESSAGE</strong>
          </span>
          <br />
          <Field
            component={MessageInputWithError}
            label='Message'
            name={`${name}.fbDmFallbackText`}
            placeholder='Fallback DM Text'
            require
          />
          <Field
            component={MessageInputWithError}
            label='Image URL'
            name={`${name}.fbDmFallbackImageUrl`}
            placeholder='Fallback DM Image URL'
          />
          <Field
            component={MessageInputWithError}
            label='Template Title'
            name={`${name}.fbTemplateFallbackTitle`}
            placeholder='Fallback Template Heading'
          />
          <Field
            component={MessageInputWithError}
            label='Template Action URL'
            name={`${name}.fbTemplateFallbackActionUrl`}
            placeholder='Fallback Template Action URL (where to go when user clicks on the DM)'
          />
          <span>
            <strong>DEPLETED MESSAGE</strong>
          </span>
          <br />
          <Field
            component={MessageInputWithError}
            label='Message'
            name={`${name}.fbDmDepletedText`}
            placeholder='Depleted DM Text'
            require
          />
          <Field
            component={MessageInputWithError}
            label='Depleted Image URL'
            name={`${name}.fbDmDepletedImageUrl`}
            placeholder='Depleted Image URL'
          />
          <Field
            component={MessageInputWithError}
            label='Template Title'
            name={`${name}.fbTemplateDepletedTitle`}
            placeholder='Depleted Template Heading'
          />
          <Field
            component={MessageInputWithError}
            label='Template Action URL'
            name={`${name}.fbTemplateDepletedActionUrl`}
            placeholder='DepletedTemplate Action URL (where to go when user clicks on the DM)'
          />
        </div>
      )}
    </div>
  )
}

SendFacebookDmFields.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string,
  includeBackupDms: PropTypes.bool,
  experienceType: PropTypes.string
}

const SendFacebookDmFieldsWithTypes = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`),
  includeBackupDms: selector(state, `${props.name}.includeBackupDms`),
  experienceType: selector(state, 'type')
}))(SendFacebookDmFields)

export default SendFacebookDmFieldsWithTypes



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/facebook/facebook-dm/index.js